import Vue from 'vue';
import VueI18n from 'vue-i18n';
import getLanguage from '../utils/getLanguage';

Vue.use(VueI18n);

// Ready translated locale messages
const messages = {
  pt: {
    home: {
      textHomeTitle: 'Comece a sua terapia online',

      TextHomeSubTitle: 'Acesso a Psicólogos de excelência a qualquer hora e em qualquer lugar',

      TextHomeSearch: 'Procure aqui um psicólogo ideal para si.',

      TextHomeScheduling: 'Agendar um atendimento é muito fácil!',

      sunTextHomeScheduling:
        'Comodamente e em segurança os pacientes do Ondivan poderão realizar o pagamento através do cartão de crédito, Débito Direto (SEPA) e Multibanco.',

      textHomeCardSearch: '1. Procure um psicólogo',

      subtextHomeCardSearch: 'textHomeCardScheduling',

      textHomeCardScheduling: '2. Agende sua consulta',

      subTextHomeCardScheduling: 'Escolha o melhor dia e horário para si.',

      textHomeCardPayment: '3. Pague online*',

      subTextHomeCardpayment: 'Comodamente e em segurança',

      ondivanDivulgText: 'O divã feito para si',

      ondivanMidiaText: 'Nos Media',

      onlineAttendance: {
        onlinePsiWhy: 'Psicólogo online. Porquê?',

        paragraphOne:
          'Na correria do dia a dia são vários os fatores que nos podem destabilizar e desequilibrar emocionalmente. A Psicologia pode ser um meio para encontrar respostas dentro de cada um de nós.',

        paragraphTwo:
          'Um psicólogo online oferece-lhe a comodidade e privacidade de ser atendido onde quer que esteja, exigindo apenas um computador ou telemóvel com uma boa ligação à internet.',

        paragraphThree:
          'Pode estar no conforto da sua casa, em viagem ou até num quarto de hotel, economizando tempo e dinheiro nas deslocações, e ainda manter a qualidade e os resultados da terapia presencial.',

        doesItWorks: 'E isso funciona?',

        paragraphFour:
          'Os profissionais do Ondivan já realizaram atendimento a pacientes em mais de 15 países e já levaram informação acerca de saúde mental para mais de 22. Aqui, encontrará psicólogos experientes e um ambiente seguro, ético e confidencial.',

        paragraphFive:
          'Caso se sinta triste, desmotivado, ansioso, angustiado, caso não consiga tomar decisões, caso encontre dificuldades para dormir, apresente comportamentos compulsivos ou muita timidez, caso esteja associado a vícios ou sinta distúrbios na sua saúde mental, procure ajuda! Um psicólogo possui ferramentas adequadas para o auxiliar.',

        paragraphSix:
          'O Ondivan reúne psicólogos de Portugal e do Brasil que irão acolhê-lo e ajudá-lo a cuidar da sua saúde mental.',

        paragraphSeven: 'Conheça já hoje os nossos profissionais!',
      },
      clientTestimonials: 'Testemunhos dos nossos clientes'
    },
    pageAbout: {
      paragraphOne:
        'O Ondivan nasce do desejo de levar o atendimento online sem fronteiras para todos os locais onde exista uma pessoa à procura de ajuda psicológica.',
      paragraphTwo:
        'Nasce também da ideia de ajudar os profissionais de psicologia a levarem a sua prestação de serviços para fora dos limites que as paredes dos nossos consultórios nos impõem.',
      paragraphThree:
        'O nosso lema é: Onde existe alguém em sofrimento psíquico, existe um profissional Ondivan para o acolher.',
      paragraphFour:
        'Somos também uma Central de Conteúdos Psicológicos que procura oferecer informações sobre a psicologia em geral, com o objetivo de promover uma atitude preventiva no que diz respeito à saúde mental. Pretendemos educar e capacitar os usuários na procura do bem-estar e construção de uma vida melhor.',
      paragraphFive:
        'A nossa plataforma proporciona aos nossos pacientes o acesso a uma equipa de psicólogos altamente qualificados, a qualquer hora e em qualquer lugar. Já aos nossos profissionais, oferecemos toda a facilidade da administração do seu consultório online que inclui, além das possibilidades da ampliação da sua carteira de pacientes, a gestão da sua agenda, o controle dos recebimentos, o prontuário para registo das sessões e a opção de divulgar os seus artigos através do nosso blog.',
      paragraphSix:
        'Posto isso, apresentamo-nos como uma clínica de psicologia da área de eHealth que oferece a Psicólogos e Pacientes a possibilidade de uma experiência diferenciada em saúde mental.',
    },
    pageLogin: {
      title: 'Conecte-se',
      labelPassword: 'Senha',
      placeholdEmail: 'Digite aqui o seu email',
      placeholdPassword: 'Digite aqui a sua senha',
      mensagem: 'Esqueceu a senha?',
      cadastrar: 'Registre-se',
    },
    pageCadastro: {
      labelPassword: 'senha',
      labelConfirmPassword: 'Confirme a sua senha',
      tooltipAba: 'Ver num novo separador',
      labelDestrito: 'Distrito',
      idDocument: 'NIF',
      psiBio: 'Saiba mais sobre mim',
      academicQualifications: 'Habilitações Académicas'
    },
    pageProfile: {
      btnSenha: 'Alterar senha',
      labelDestrito: 'Distrito',
      titleContato: 'Contactos',
      titleEmergencia: 'Contactos de Emergência',
      oppOrCrp: 'OPP',
      psiBio: 'Saiba mais sobre mim',
    },
    pageEditProfile: {
      btnSalvar: 'Guardar',
      psiBio: 'Saiba mais sobre mim',
    },
    pageSenha: {
      title: 'Esqueci a senha',
    },
    pageConsulta: {
      titleContato: 'Contactos',
    },
    pageCreateAgenda: {
      btnSalvar: 'Guardar',
    },
    queryDetail: {
      coupon: 'Cupão',
    },
    navBar: {
      coupon: 'Cupão',
      description1: "Caso deseje realizar algum abatimento no valor da consulta do seu paciente, o ONDIVAN cria um cupom de desconto para você!",
      description2: "Entre em contato com o nosso",
      description3: "para saber como funciona.",
    },
    pagePsychologist: {
      terms: 'OOP',
    },
    schedulingPage: {
      coupon: 'Cupão',
      discountCoupon: 'Cupão de Desconto',
      typeYourCoupon: 'Digite seu cupão',
    },
    // revr fluxo
    dateBank: {
      types: {
        firstType: 'Empresa',
        secondType: 'ENI',
      },
      identifyNumber: 'VAT/NIF',
      numberAccount: 'Código IBAN',
      title: 'Cadastro de Conta Digital',
      identityDocument: 'Comprovante de documento de identidade',
      yourAddress: 'Seu endereço'
    },
    partners: {
      contact: 'Entre em contacto connosco!',
    },
    couponPage: {
      searchByCouponName: 'Busque pelo nome do cupão',
      couponNotFound: 'Não encontramos nenhum cupão disponível.',
    },
    publicNavBar: {
      blog: 'Blogue'
    },
    psiFinancial: {
      title: 'Receita',
      subtitle: "Faça a gestão dos seus ganhos."
    },
    patientFinancial: {
      title: 'Controle de pagamentos',
      subtitle: "Faça a gestão dos seus pagamentos."
    },
    patientPayment: {
      title: "Formas de Pagamento",
      subtitle: "Aqui você pode inserir e alterar os meios que deseja utilizar para realizar o pagamento das sessões."
    },
    patientSearchPsi: {
      title: "Pesquisa de profissionais",
      subtitle: "Encontre aqui o profissional que mais se adequa às suas necessidades."
    },
    footer: {
      opp: 'OPP: CP 23204'
    }
  },
  'pt-BR': {
    home: {
      textHomeTitle: 'Comece a sua terapia online',

      TextHomeSubTitle: 'Acesso a Psicólogos de excelência a qualquer hora e em qualquer lugar',

      TextHomeSearch: 'Procure aqui o psicólogo ideal para você.',

      TextHomeScheduling: 'Agendar um atendimento é muito fácil!',

      sunTextHomeScheduling:
        'Com facilidade e segurança os pacientes do Ondivan poderão realizar os pagamentos através do cartão de crédito.',

      textHomeCardSearch: '1. Procure um psicólogo',

      subtextHomeCardSearch: 'textHomeCardScheduling',

      textHomeCardScheduling: '2. Agende sua consulta',

      subTextHomeCardScheduling: 'Escolha o melhor dia e horário para você',

      textHomeCardPayment: '3. Pague online*',

      subTextHomeCardpayment: 'Comodamente e em segurança',

      ondivanDivulgText: 'O divã feito para você',

      ondivanMidiaText: 'Na Mídia',

      onlineAttendance: {
        onlinePsiWhy: 'Psicólogo online. Porquê?',

        paragraphOne:
          'Na correria do dia a dia são vários os fatores que podem nos destabilizar e desequilibrar emocionalmente. A Psicologia pode ser um meio para encontrar respostas dentro de cada um de nós.',

        paragraphTwo:
          'Um psicólogo online oferece a comodidade e privacidade de ser atendido onde quer que esteja, exigindo apenas um computador ou celular com uma boa ligação à internet.',

        paragraphThree:
          'Você pode estar no conforto da sua casa, em viagem ou até num quarto de hotel, economizando tempo e dinheiro nas deslocações, e ainda manter a qualidade e os resultados da terapia presencial.',

        doesItWorks: 'E isso funciona?',

        paragraphFour:
          'Os profissionais do Ondivan já realizaram atendimento a pacientes em mais de 15 países e já levaram informação acerca de saúde mental para mais de 22. Aqui, encontrará psicólogos experientes e um ambiente seguro, ético e confidencial.',

        paragraphFive:
          'Caso se sinta triste, desmotivado, ansioso, angustiado, caso não consiga tomar decisões, caso encontre dificuldades para dormir, apresente comportamentos compulsivos ou muita timidez, caso esteja associado a vícios ou sinta distúrbios na sua saúde mental, procure ajuda! Um psicólogo possui ferramentas adequadas para o auxiliar.',

        paragraphSix:
          'O Ondivan reúne psicólogos de Portugal e do Brasil que irão acolhê-lo e ajudá-lo a cuidar da sua saúde mental.',

        paragraphSeven: 'Conheça hoje os nossos profissionais!',
      },
      clientTestimonials: 'Depoimentos dos nossos clientes'
    },
    pageAbout: {
      paragraphOne:
        'O Ondivan nasceu do desejo de levar o atendimento online sem fronteiras para todos os locais onde exista uma pessoa à procura de ajuda psicológica.',
      paragraphTwo:
        'Nasceu também da ideia de ajudar os profissionais de psicologia a levarem a sua prestação de serviços para fora dos limites que as paredes dos nossos consultórios nos impõem.',
      paragraphThree:
        'O nosso lema é: Onde existe alguém em sofrimento psíquico, existe um profissional Ondivan para o acolher.',
      paragraphFour:
        'Somos também uma Central de Conteúdos Psicológicos que procura oferecer informações sobre a psicologia em geral, com o objetivo de promover uma atitude preventiva no que diz respeito à saúde mental. Pretendemos educar e capacitar os usuários na procura do bem-estar e construção de uma vida melhor.',
      paragraphFive:
        'A nossa plataforma proporciona aos nossos pacientes o acesso a uma equipe de psicólogos altamente qualificados, a qualquer hora e em qualquer lugar. Já aos nossos profissionais, oferecemos toda a facilidade da administração do seu consultório online que inclui, além das possibilidades da ampliação da sua carteira de pacientes, a gestão da sua agenda, o controle dos recebimentos, o prontuário para registo das sessões e a opção de divulgar os seus artigos através do nosso blog.',
      paragraphSix:
        'Posto isso, apresentamo-nos como uma clínica de psicologia da área de eHealth que oferece a Psicólogos e Pacientes a possibilidade de uma experiência diferenciada em saúde mental.',
    },
    pageLogin: {
      title: 'Entrar',
      labelPassword: 'Senha',
      placeholdEmail: 'Digite aqui o seu email',
      placeholdPassword: 'Digite aqui a sua senha',
      mensagem: 'Esqueceu a senha?',
      cadastrar: 'Cadastre-se',
    },
    pageCadastro: {
      labelPassword: 'Senha',
      labelConfirmPassword: 'Confirme a sua Senha',
      tooltipAba: 'Abre em uma nova aba',
      labelDestrito: 'Estado',
      idDocument: 'CPF',
      psiBio: 'Saiba mais sobre mim',
      academicQualifications: 'Habilitações Acadêmicas'
    },
    pageProfile: {
      btnSenha: 'Alterar Senha',
      labelDestrito: 'Estado',
      titleContato: 'Contatos',
      titleEmergencia: 'Contatos emergencial',
      oppOrCrp: 'CRP',
      psiBio: 'Saiba mais sobre mim',
    },
    pageEditProfile: {
      btnSalvar: 'Salvar',
      psiBio: 'Saiba mais sobre mim',
    },
    pageSenha: {
      title: 'Esqueci a senha',
    },
    pageConsulta: {
      titleContato: 'Contatos',
    },
    pageCreateAgenda: {
      btnSalvar: 'Salvar',
    },
    dateBank: {
      types: {
        firstType: 'Individual',
        secondType: 'Individual',
      },
      identifyNumber: 'CPF',
      numberAccount: 'Numero da conta',
      title: 'Cadastro de Conta Bancária',
      identityDocument: 'Comprovante de documento de identidade (frente e verso)',
      yourAddress: 'Rua'
    },
    partners: {
      contact: 'Entre em contato conosco!',
    },
    queryDetail: {
      coupon: 'Cupom',
    },
    navBar: {
      coupon: 'Cupom',
      description1: "Caso deseje realizar algum abatimento no valor da consulta do seu paciente, o ONDIVAN cria um cupom de desconto para você!",
      description2: "Entre em contato com o nosso",
      description3: "para saber como funciona.",
    },
    couponPage: {
      searchByCouponName: 'Busque pelo nome do cupom',
      couponNotFound: 'Não encontramos nenhum cupom disponível.',
    },
    schedulingPage: {
      coupon: 'Cupom',
      discountCoupon: 'Cupom de Desconto',
      typeYourCoupon: 'Digite seu cupom',
    },
    publicNavBar: {
      blog: 'Blog'
    },
    psiFinancial: {
      title: 'Financeiro',
      subtitle: "Faça a gestão dos seus ganhos."
    },
    patientFinancial: {
      title: 'Controle de pagamentos',
      subtitle: "Faça a gestão dos seus pagamentos."
    },
    patientPayment: {
      title: "Formas de Pagamento",
      subtitle: "Aqui você pode inserir e alterar os meios que deseja utilizar para realizar o pagamento das sessões."
    },
    patientSearchPsi: {
      title: "Pesquisa de profissionais",
      subtitle: "Encontre aqui o profissional que mais se adequa às suas necessidades."
    },
    footer: {
      opp: 'CRP 03/9904'
    }
  },
};

// const userLang = navigator.language || navigator.userLanguage;
// const user = JSON.parse(localStorage.getItem('user-data'));
// const { language } = navigator;
const language = getLanguage(window.location.href);
// if (user != null) language = user.language;
console.log(language);

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: language || 'pt', // set locale
  fallbackLocale: 'pt',
  formatFallbackMessages: true,
  messages, // set locale messages
});

export default i18n;
